import requestAction from '../../utils/requestAction'

export const fetchCountries = (params: string = "") =>
  requestAction('COUNTRIES_LIST', params)(`countries`, 'GET')

export const fetchAllCountries = () =>
  fetchCountries('?all=true')